<template>
  <BaseDialog
    v-model="showDialog"
    :title="title"
    :subtitle="subtitle"
    :dialogIcon="icon"
    btnActionName="Lukk"
    :persistent="true"
    @action="$emit('action')"
  >
    <template v-slot>
      <div>
        Bruker har vært inaktiv og har derfor blitt logget ut! For å komme til
        innloggingssiden trykk lukk!
      </div>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    icon: {
      type: String,
    },
    text: {
      type: String,
    },
    btnActionName: {
      default: null,
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    BaseDialog,
  },
});
</script>
